/**
 * Orbit Blocks React App Entry Point
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import OrbitAPI from './utils/api';
import App from './components/App';

// Make API available globally for WordPress integration
window.OrbitAPI = OrbitAPI;

// Mount React app when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
	const container = document.getElementById('orbit-blocks-app');
	if (!container) {
		console.error('Container element #orbit-blocks-app not found');
		return;
	}

	// Get mode from config (defaults to 'admin')
	const mode = window.orbitConfig?.mode || 'admin';

	try {
		// Try React 18+ createRoot first
		if (ReactDOM.createRoot && typeof ReactDOM.createRoot === 'function') {
			const root = ReactDOM.createRoot(container);
			root.render(React.createElement(App, { mode }));
		} else {
			// Fallback to legacy ReactDOM.render
			const legacyReactDOM = ReactDOM.render || ReactDOM.default?.render;
			if (legacyReactDOM) {
				legacyReactDOM(React.createElement(App, { mode }), container);
			} else {
				throw new Error('No valid React render method found');
			}
		}
	} catch (error) {
		console.error('Failed to mount React app:', error);
		
		// Final fallback - try WordPress React if available
		if (typeof wp !== 'undefined' && wp.element && wp.element.render) {
			try {
				wp.element.render(wp.element.createElement(App), container);
			} catch (wpError) {
				container.innerHTML = '<div style="padding: 20px; color: red;">Failed to load Orbit Blocks app. Please refresh the page.</div>';
			}
		} else {
			container.innerHTML = '<div style="padding: 20px; color: red;">React failed to load. Please refresh the page or contact support.</div>';
		}
	}
});